import React from 'react';

const OpenTelemetryObservability = () => (
  <div className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-800 mb-8" data-aos="fade-up">
          OpenTelemetry & Observability
        </h1>
        <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-600" data-aos="fade-up" data-aos-delay="100">
          <p className="text-lg text-gray-700 mb-6">
            <strong>OpenTelemetry</strong> is an open-source framework for collecting, processing, and exporting telemetry data (metrics, logs, and traces) from cloud-native applications. It is a CNCF project and has become the industry standard for observability.
          </p>
          <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-8">How OpenTelemetry Works</h2>
          <p className="mb-4 text-gray-700">
            OpenTelemetry provides SDKs and agents that instrument your code and infrastructure. Data is collected and sent to observability platforms like Prometheus, Jaeger, or Grafana for visualization and analysis.
          </p>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li><strong>Metrics:</strong> Quantitative data about system performance and resource usage</li>
            <li><strong>Logs:</strong> Text records of events for debugging and auditing</li>
            <li><strong>Traces:</strong> End-to-end request flows across distributed services</li>
          </ul>
          <h2 className="text-2xl font-bold text-blue-700 mb-4 mt-8">Organizational Benefits</h2>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li>Unified observability across diverse systems</li>
            <li>Faster troubleshooting and root cause analysis</li>
            <li>Improved reliability and performance optimization</li>
            <li>Enables data-driven decision making for engineering teams</li>
          </ul>
          <p className="text-gray-700">
            Organizations adopting OpenTelemetry gain comprehensive visibility, reduce downtime, and deliver better user experiences.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default OpenTelemetryObservability;
